<template>
  <UninstallLayout 
    :title="$t('uninstall.codeManagement.title')"
  >
    <template #leftContent>
        <div class="d-flex flex-column">
          <span class="typo-title1 text-light-high weight-600 mb-1">
            {{ $t('uninstall.codeManagement.cautionList.title')  }}
          </span>
          <ul class="caution-list mb-3 text-dark6">
            <li v-for="item in cautionListItem" :key="item">
              {{ item }}
            </li>
          </ul>
          <div class="d-flex flex-column">
            <span class="text-dark6 mb-1" v-html="$t('uninstall.codeManagement.confirmInput.label')"/>
            <input
              v-model="confirmValue"
              type="text"
              class="input-field input-field-block"
              :placeholder="$t('uninstall.codeManagement.confirmInput.placeholder')"
              :disabled="isRemovingCode"
            />
          </div>
        </div>
        <div class="d-flex">
          <button class="btn btn-secondary2 px-2 mr-2" @click="handleContinueUninstall" :disabled="isRemovingCode">
            {{ $t('uninstall.codeManagement.action.secondary.label') }}
          </button>
          <ProcessButton
            class="btn-default px-2"
            type="submit"
            default="btn-danger2"
            :status.sync="btnStatus"
            @click="handleRemoveCode"
            :disabled="isDisabled"
          >
            <template #default>{{ $t('uninstall.codeManagement.action.primary.label') }}</template>
            <template #loading>{{ $t('uninstall.codeManagement.action.primary.loading.label') }}</template>
            <template #success>{{ $t("generals.success") }}</template>
            <template #error>{{ $t("generals.error") }}</template>
          </ProcessButton>
        </div>
    </template>
  </UninstallLayout>
</template>

<script>
import { Api, ApiUrl } from "@/services";
import errorHandle from "@/mixins/errorHandle.js";
import initProcessButton from "@/mixins/processButton.js";
import UninstallLayout from "../components/UninstallLayout.vue";

const CONFIRM_VALUE = 'confirm';
const SOCKET_EVENT = 'shop_uninstall';
const ON_TO_NEXT_PAGE_TIMEOUT = 700;

export default {
  name: 'UninstallRemoveCode',
  components: {
    UninstallLayout,
  },
  mixins: [initProcessButton(), errorHandle()],
  data() {
    return {
      confirmValue: '',
      isRemovingCode: false,
      cautionListItem: [
        this.$t('uninstall.codeManagement.cautionList.item1'),
        this.$t('uninstall.codeManagement.cautionList.item2'),
        this.$t('uninstall.codeManagement.cautionList.item3'),
        this.$t('uninstall.codeManagement.cautionList.item4'),
        this.$t('uninstall.codeManagement.cautionList.item5'),
      ]
    }
  },
  computed: {
    isDisabled() {
      return this.confirmValue.trim() !== CONFIRM_VALUE
    }
  },
  mounted () {
    this.handleWebSocket();
  },
  methods: {
    async handleRemoveCode() {
      try {
        this.activeLoading();
        // await UninstallApi.removeAllTemplatesApi();
        await Api.base.post(ApiUrl.base.uninstall);
        this.handleWebSocket();
      } catch (error) {
        this.onError(error)
      }
    },
    handleWebSocket() {
      const isSocket = window._webSocket && window._webSocket.connection.readyState === 1;
      
      isSocket
        ? window._webSocket.onmessage(SOCKET_EVENT, (data) => this.onCheckRemoveCodeProgress(data))
        : this.onSuccess();
    },
    onCheckRemoveCodeProgress(data) {
      if(!this.btnStatus.loading) {
        this.activeLoading();
      }

      this.confirmValue = CONFIRM_VALUE;
      this.isRemovingCode = true;

      const removeCodeError = data.status === 'error' && data.step === data.totalStep;
      const removeCodeSuccess = data.status === 'success' && data.step === data.totalStep;

      if (removeCodeSuccess) {
        this.onSuccess();
        this.disconnectSocket();
        return;
      }
      
      if (removeCodeError) {
        this.onError(data.message);
        this.disconnectSocket();
        return;
      }
    },
    onSuccess() {
      this.isRemovingCode = false;
      this.resetStatus();
      this.gSnackbarCommit({
        message: 'Remove code successfully',
        type: "success"
      });

      setTimeout(() => {
        this.handleContinueUninstall();
      }, ON_TO_NEXT_PAGE_TIMEOUT);
    },
    onError(error) {
      this.resetStatus();
      this.isRemovingCode = false;
      this.gSnackbarCommit({
        message: error || 'Error: Remove code failed',
        type: "error"
      });
    },
    disconnectSocket() {
      window._webSocket.offmessage(SOCKET_EVENT);
    },
    handleContinueUninstall() {
      this.$emit('continue');
    }
  },
}
</script>

<style scoped lang="scss">
  .btn {
    height: 40px !important;
  }

  .caution-list {
    line-height: 24px;
    margin-left: 24px;
  }

  .input-field {
    height: 40px;
    width: 384px;
    border-radius: 3px !important;
    background: $light2 !important;

    &:not(:focus):hover {
      background: $textDarkModeHigh !important
    }
  }
</style>
